import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "g-content" };
const _hoisted_2 = {
    key: 0,
    class: "container-fluid w-100 pt-2 pb-2 mb-3",
    style: { "border-bottom": "1px dashed #dee2e6" }
};
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-8 pl-2" };
const _hoisted_5 = { class: "col-4 pr-2 command-bar" };
const _hoisted_6 = { class: "row h-100" };
const _hoisted_7 = {
    key: 0,
    class: "d-none d-lg-block col-lg-3 col-xl-3 pe-0 border-end"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_breadcrumb = _resolveComponent("g-breadcrumb");
    const _component_portal_target = _resolveComponent("portal-target");
    const _component_router_view = _resolveComponent("router-view");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showCommandBar)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_g_breadcrumb)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_portal_target, {
                            name: "command-bar",
                            multiple: ""
                        })
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", {
            class: _normalizeClass(['container-fluid p-0 h-100', !_ctx.showCommandBar ? 'mt-4' : ''])
        }, [
            _createElementVNode("div", _hoisted_6, [
                (_ctx._sidebar)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx._sidebar.component), _normalizeProps(_guardReactiveProps(_ctx._sidebar.attributes)), null, 16))
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", {
                    class: _normalizeClass([_ctx._sidebar ? 'col-lg-9 col-xl-9' : 'col-lg-12 p-0'])
                }, [
                    _createVNode(_component_router_view)
                ], 2)
            ])
        ], 2)
    ]));
}
